const galeryImage = [
    'galeria1.jpg',
    'galeria2.jpg',
    'galeria3.jpeg',
    'galeria4.jpg',
    'galeria5.jpg',
    'galeria6.jpg',
    'galeria7.jpg',
    'galeria8.jpg',
    'galeria9.jpeg',
    'galeria10.jpg',
    'galeria11.jpg',
    'galeria12.jpg',
]

export default galeryImage;